import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useUser } from "../UserContext";
import {
  // FaBook,
  // FaTasks,
  // FaChartBar,
  // FaEnvelope,
  // FaHospital,
  // FaStethoscope,
  // FaNotesMedical,
  // FaUserMd,
  FaBook,
  FaTasks,
  FaChartBar,
  FaEnvelope,
  FaUserCircle,
  FaClipboardList,
  FaExclamationTriangle,
  FaCheckCircle,
} from "react-icons/fa";

const StudentHome = () => {
  const [studentDetails, setStudentDetails] = useState(null);
  const { user } = useUser();

  // Dashboard statistics
  const [dashboardStats, setDashboardStats] = useState({
    approvedAssignments: 0,
    rejectedAssignments: 0,
    assignedCases: 0,
  });

  // **1) NEW: Courses list → holds only "available" courses**
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ────────────────────────────────────────────────────────────
  //  2) Fetch all report PDFs (approved vs. rejected)
  // ────────────────────────────────────────────────────────────
  const fetchPendingReports = useCallback(async () => {
    setLoading(true);
    try {
      const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
      const { data } = await axios.get(`${apiUrl}/api/get-all-report-pdf`, {
        params: { username: user?.username },
      });

      const approvedReports = data.filter((report) => report.status === "approved");
      const rejectedReports = data.filter((report) => report.status === "rejected");

      setDashboardStats((prev) => ({
        ...prev,
        approvedAssignments: approvedReports.length,
        rejectedAssignments: rejectedReports.length,
      }));
    } catch (err) {
      console.error("Error fetching reports:", err);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user?.username) {
      fetchPendingReports();
    }
  }, [fetchPendingReports, user?.username]);

  // ────────────────────────────────────────────────────────────
  //  3) Load Student Details from sessionStorage
  // ────────────────────────────────────────────────────────────
  useEffect(() => {
    try {
      const userStr = sessionStorage.getItem("user");
      if (!userStr) return;
      const storedUser = JSON.parse(userStr);
      if (storedUser && storedUser.name) {
        setStudentDetails(storedUser);
      }
    } catch (err) {
      console.error("Error parsing user data:", err);
    }
  }, []);

  // ────────────────────────────────────────────────────────────
  //  4) FETCH AVAILABLE COURSES (instead of "topics")
  // ────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        const userStr = sessionStorage.getItem("user");
        if (!userStr) {
          throw new Error("User not logged in");
        }
        const storedUser = JSON.parse(userStr);

        const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
        const response = await fetch(`${apiUrl}/api/student/courses/${storedUser.id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        console.log("Fetched courses:", data);
        setCourses(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching courses:", err);
        setError("Failed to load courses data.");
      } finally {
        setLoading(false);
      }
    };

    if (studentDetails && studentDetails.id) {
      fetchCourses();
    }
  }, [studentDetails]);

  // ────────────────────────────────────────────────────────────
  //  5) Fetch Assigned "Case" Count (unchanged)
  // ────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchAssignedCases = async () => {
      try {
        const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
        const response = await axios.get(`${apiUrl}/api/student/assignments/case/${user.id}`);
        setDashboardStats((prev) => ({
          ...prev,
          assignedCases: response.data.length,
        }));
      } catch (err) {
        console.error("Error fetching assigned cases:", err);
      }
    };

    if (user?.id) {
      fetchAssignedCases();
    }
  }, [user]);

  // ────────────────────────────────────────────────────────────
  //  6) RENDER JSX (use `courses.length` for "Available Modules")
  // ────────────────────────────────────────────────────────────
  // return (
  //   <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
  //     <div className="w-[95%] mx-auto bg-white p-8 shadow-xl backdrop-blur-lg border border-gray-200 rounded-2xl">
  //       {studentDetails ? (
  //         <div className="text-center">
  //           {/* Profile Section with Healthcare Theme */}
  //           <div className="flex flex-col items-center mb-10">
  //             <div className="bg-gradient-to-r from-blue-600 to-teal-500 text-white p-4 rounded-full mb-4 shadow-lg">
  //               <FaUserMd className="text-8xl drop-shadow-md" />
  //             </div>
  //             <div className="bg-gradient-to-r from-blue-600 to-teal-500 text-white px-10 py-4 rounded-xl shadow-lg">
  //               <h1 className="text-4xl font-bold tracking-wide">Welcome, Dr. {studentDetails.name}</h1>
  //               <p className="text-xl mt-2 font-light">{studentDetails.role}</p>
  //             </div>
  //           </div>

  //           {/* Statistics Section with Medical Theme */}
  //           {loading ? (
  //             <div className="flex justify-center items-center h-40">
  //               <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  //             </div>
  //           ) : error ? (
  //             <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg">
  //               <p className="text-center">{error}</p>
  //             </div>
  //           ) : (
  //             <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
  //               <div className="stat-card bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 text-blue-900 p-8 rounded-xl shadow-lg">
  //                 <FaHospital className="text-5xl mx-auto text-blue-600 mb-4" />
  //                 <h3 className="text-xl font-semibold mb-2">Available Courses</h3>
  //                 <p className="text-4xl font-bold">{courses.length}</p>
  //               </div>

  //               <Link
  //                 to="/student-dashboard/approved-assignments"
  //                 className="stat-card bg-gradient-to-br from-green-50 to-green-100 border border-green-200 text-green-900 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 block"
  //               >
  //                 <FaStethoscope className="text-5xl mx-auto text-green-600 mb-4" />
  //                 <h3 className="text-xl font-semibold mb-2">Approved Cases</h3>
  //                 <p className="text-4xl font-bold">{dashboardStats.approvedAssignments}</p>
  //               </Link>

  //               <Link
  //                 to="/student-dashboard/rejected-assignments"
  //                 className="stat-card bg-gradient-to-br from-red-50 to-red-100 border border-red-200 text-red-900 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 block"
  //               >
  //                 <FaNotesMedical className="text-5xl mx-auto text-red-600 mb-4" />
  //                 <h3 className="text-xl font-semibold mb-2">Rejected Reports</h3>
  //                 <p className="text-4xl font-bold">{dashboardStats.rejectedAssignments}</p>
  //               </Link>
  //             </div>
  //           )}

  //           {/* Action Cards with Medical Theme */}
  //           <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-12">
  //             <Link
  //               to="/student-dashboard/courses/ongoing"
  //               className="group flex flex-col items-center justify-center gap-4 p-8
  //                        bg-gradient-to-br from-blue-600 to-blue-500 text-white
  //                        rounded-xl shadow-lg transition-all duration-300
  //                        cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-blue-400/50"
  //             >
  //               <FaBook className="text-5xl group-hover:scale-110 transition-all duration-300" />
  //               <span className="text-xl font-semibold tracking-wide">Medical Courses</span>
  //             </Link>

  //             <Link
  //               to="/student-dashboard/report-generation"
  //               className="group flex flex-col items-center justify-center gap-4 p-8
  //                        bg-gradient-to-br from-teal-600 to-teal-500 text-white
  //                        rounded-xl shadow-lg transition-all duration-300
  //                        cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-teal-400/50"
  //             >
  //               <FaTasks className="text-5xl group-hover:scale-110 transition-all duration-300" />
  //               <span className="text-xl font-semibold tracking-wide">Case Reports</span>
  //             </Link>

  //             <Link
  //               to="/student-dashboard/forums"
  //               className="group flex flex-col items-center justify-center gap-4 p-8
  //                        bg-gradient-to-br from-purple-600 to-purple-500 text-white
  //                        rounded-xl shadow-lg transition-all duration-300
  //                        cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-purple-400/50"
  //             >
  //               <FaChartBar className="text-5xl group-hover:scale-110 transition-all duration-300" />
  //               <span className="text-xl font-semibold tracking-wide">Medical Forums</span>
  //             </Link>

  //             <Link
  //               to="/student-dashboard/student-messages"
  //               className="group flex flex-col items-center justify-center gap-4 p-8
  //                        bg-gradient-to-br from-indigo-600 to-indigo-500 text-white
  //                        rounded-xl shadow-lg transition-all duration-300
  //                        cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-indigo-400/50"
  //             >
  //               <FaEnvelope className="text-5xl group-hover:scale-110 transition-all duration-300" />
  //               <span className="text-xl font-semibold tracking-wide">Messages</span>
  //             </Link>
  //           </div>
  //         </div>
  //       ) : (
  //         <div className="bg-red-50 border border-red-200 text-red-700 p-6 rounded-lg text-center">
  //           <p className="text-xl">Access Denied. Please log in to continue.</p>
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // );
  // return (
  //   <div className="flex flex-col items-center justify-center min-h-screen">
  //     {/* Main Card */}
  //     <div
  //       className="w-[90%] mx-auto bg-white p-10 shadow-2xl 
  //                  backdrop-blur-lg border border-gray-300 rounded-xl"
  //     >
  //       {studentDetails ? (
  //         <div className="text-center">
  //           {/* Profile Section */}
  //           <div className="flex flex-col items-center mb-8">
  //             <div className="bg-blue-600 text-white p-3 rounded-full mb-4">
  //               <FaUserCircle className="text-7xl drop-shadow-md" />
  //             </div>
  //             <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-md">
  //               <h1 className="text-3xl font-bold">
  //                 Welcome, {studentDetails.name}
  //               </h1>
  //               <p className="text-lg mt-1">{studentDetails.role}</p>
  //             </div>
  //           </div>

  //           {/* Statistics Section */}
  //           {loading ? (
  //             <p className="text-center text-gray-700">Loading topics data...</p>
  //           ) : error ? (
  //             <p className="text-center text-red-500">{error}</p>
  //           ) : (
  //             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
  //               <div className="stat-card bg-blue-50 border border-blue-300 text-blue-900 p-6 rounded-lg shadow-lg">
  //                 <FaClipboardList className="text-4xl mx-auto text-blue-600 mb-2" />
  //                 <h3 className="text-lg font-semibold">Available Modules</h3>
  //                 <p className="text-3xl font-bold">{topics.length + dashboardStats.assignedCases}</p>
  //               </div>

  //               <Link to="/student-dashboard/approved-assignments" className="stat-card bg-green-50 border border-green-300 text-green-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-green-100 transition block">
  //                 <FaExclamationTriangle className="text-4xl mx-auto text-green-600 mb-2" />
  //                 <h3 className="text-lg font-semibold">Approved Assignments</h3>
  //                 <p className="text-3xl font-bold">{dashboardStats.approvedAssignments}</p>
  //               </Link>

  //               <Link to="/student-dashboard/rejected-assignments" className="stat-card bg-red-50 border border-red-300 text-red-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-red-100 transition block">
  //                 <FaCheckCircle className="text-4xl mx-auto text-red-600 mb-2" />
  //                 <h3 className="text-lg font-semibold">Rejected Assignments</h3>
  //                 <p className="text-3xl font-bold">{dashboardStats.rejectedAssignments}</p>
  //               </Link>
  //             </div>
  //           )}

  //           {/* Action Cards */}
  //           <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
  //             <Link
  //               to="/student-dashboard/topic"
  //               className="group flex flex-col items-center justify-center gap-3 p-6 
  //                          bg-gradient-to-r from-blue-500 to-blue-400 text-white 
  //                          rounded-xl shadow-md transition-all duration-300 
  //                          cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-blue-400/50"
  //             >
  //               <FaBook className="text-4xl group-hover:scale-110 transition-all duration-300" />
  //               <span className="text-lg font-semibold tracking-wide">
  //                 My Courses
  //               </span>
  //             </Link>

  //             <Link
  //               to="/student-dashboard/courses/ongoing"
  //               className="group flex flex-col items-center justify-center gap-3 p-6 
  //                          bg-gradient-to-r from-green-500 to-teal-400 text-white 
  //                          rounded-xl shadow-md transition-all duration-300 
  //                          cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-green-400/50"
  //             >
  //               <FaTasks className="text-4xl group-hover:scale-110 transition-all duration-300" />
  //               <span className="text-lg font-semibold tracking-wide">
  //                 Report Generation
  //               </span>
  //             </Link>

  //             <Link
  //               to="/student-dashboard/forums"
  //               className="group flex flex-col items-center justify-center gap-3 p-6 
  //                          bg-gradient-to-r from-yellow-500 to-orange-400 text-white 
  //                          rounded-xl shadow-md transition-all duration-300 
  //                          cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-yellow-400/50"
  //             >
  //               <FaChartBar className="text-4xl group-hover:scale-110 transition-all duration-300" />
  //               <span className="text-lg font-semibold tracking-wide">
  //                 Forums
  //               </span>
  //             </Link>

  //             <Link
  //               to="/student-dashboard/student-messages"
  //               className="group flex flex-col items-center justify-center gap-3 p-6 
  //                          bg-gradient-to-r from-purple-500 to-pink-500 text-white 
  //                          rounded-xl shadow-md transition-all duration-300 
  //                          cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-pink-400/50"
  //             >
  //               <FaEnvelope className="text-4xl group-hover:scale-110 transition-all duration-300" />
  //               <span className="text-lg font-semibold tracking-wide">
  //                 Messages
  //               </span>
  //             </Link>
  //           </div>
  //         </div>
  //       ) : (
  //         <p className="text-center text-red-500">
  //           Access Denied. Please log in.
  //         </p>
  //       )}
  //     </div>
  //   </div>
  // );
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      {/* Main Card */}
      <div
        className="w-[90%] mx-auto bg-white p-10 shadow-2xl 
                   backdrop-blur-lg border border-gray-300 rounded-xl"
      >
        {studentDetails ? (
          <div className="text-center">
            {/* Profile Section */}
            <div className="flex flex-col items-center mb-8">
              <div className="bg-blue-600 text-white p-3 rounded-full mb-4">
                <FaUserCircle className="text-7xl drop-shadow-md" />
              </div>
              <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-md">
                <h1 className="text-3xl font-bold">
                  Welcome, {studentDetails.name}
                </h1>
                <p className="text-lg mt-1">{studentDetails.role}</p>
              </div>
            </div>

            {/* Statistics Section */}
            {loading ? (
              <p className="text-center text-gray-700">Loading topics data...</p>
            ) : error ? (
              <p className="text-center text-red-500">{error}</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
                <div className="stat-card bg-blue-50 border border-blue-300 text-blue-900 p-6 rounded-lg shadow-lg">
                  <FaClipboardList className="text-4xl mx-auto text-blue-600 mb-2" />
                  <h3 className="text-lg font-semibold">Available Modules</h3>
                  <p className="text-3xl font-bold">{courses.length + dashboardStats.assignedCases}</p>
                </div>

                <Link to="/student-dashboard/approved-assignments" className="stat-card bg-green-50 border border-green-300 text-green-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-green-100 transition block">
                  <FaExclamationTriangle className="text-4xl mx-auto text-green-600 mb-2" />
                  <h3 className="text-lg font-semibold">Approved Assignments</h3>
                  <p className="text-3xl font-bold">{dashboardStats.approvedAssignments}</p>
                </Link>

                <Link to="/student-dashboard/rejected-assignments" className="stat-card bg-red-50 border border-red-300 text-red-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-red-100 transition block">
                  <FaCheckCircle className="text-4xl mx-auto text-red-600 mb-2" />
                  <h3 className="text-lg font-semibold">Rejected Assignments</h3>
                  <p className="text-3xl font-bold">{dashboardStats.rejectedAssignments}</p>
                </Link>
              </div>
            )}

            {/* Action Cards */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
              <Link
                to="/student-dashboard/topic"
                className="group flex flex-col items-center justify-center gap-3 p-6 
                           bg-gradient-to-r from-blue-500 to-blue-400 text-white 
                           rounded-xl shadow-md transition-all duration-300 
                           cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-blue-400/50"
              >
                <FaBook className="text-4xl group-hover:scale-110 transition-all duration-300" />
                <span className="text-lg font-semibold tracking-wide">
                  My Courses
                </span>
              </Link>

              <Link
                to="/student-dashboard/courses/ongoing"
                className="group flex flex-col items-center justify-center gap-3 p-6 
                           bg-gradient-to-r from-green-500 to-teal-400 text-white 
                           rounded-xl shadow-md transition-all duration-300 
                           cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-green-400/50"
              >
                <FaTasks className="text-4xl group-hover:scale-110 transition-all duration-300" />
                <span className="text-lg font-semibold tracking-wide">
                  Report Generation
                </span>
              </Link>

              <Link
                to="/student-dashboard/forums"
                className="group flex flex-col items-center justify-center gap-3 p-6 
                           bg-gradient-to-r from-yellow-500 to-orange-400 text-white 
                           rounded-xl shadow-md transition-all duration-300 
                           cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-yellow-400/50"
              >
                <FaChartBar className="text-4xl group-hover:scale-110 transition-all duration-300" />
                <span className="text-lg font-semibold tracking-wide">
                  Forums
                </span>
              </Link>

              <Link
                to="/student-dashboard/student-messages"
                className="group flex flex-col items-center justify-center gap-3 p-6 
                           bg-gradient-to-r from-purple-500 to-pink-500 text-white 
                           rounded-xl shadow-md transition-all duration-300 
                           cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-pink-400/50"
              >
                <FaEnvelope className="text-4xl group-hover:scale-110 transition-all duration-300" />
                <span className="text-lg font-semibold tracking-wide">
                  Messages
                </span>
              </Link>
            </div>
          </div>
        ) : (
          <p className="text-center text-red-500">
            Access Denied. Please log in.
          </p>
        )}
      </div>
    </div>
  );
};

export default StudentHome;
